import { render, staticRenderFns } from "./FutureUpdates.vue?vue&type=template&id=5780d06a&scoped=true&"
import script from "./FutureUpdates.vue?vue&type=script&lang=js&"
export * from "./FutureUpdates.vue?vue&type=script&lang=js&"
import style0 from "./FutureUpdates.vue?vue&type=style&index=0&id=5780d06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780d06a",
  null
  
)

export default component.exports